import { render, staticRenderFns } from "./InventoryItemsList.vue?vue&type=template&id=741d9c0f&scoped=true"
import script from "./InventoryItemsList.vue?vue&type=script&lang=js"
export * from "./InventoryItemsList.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemsList.vue?vue&type=style&index=0&id=741d9c0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d9c0f",
  null
  
)

export default component.exports